const appVersion = require('../../package.json').version;

export const environment = {
  production: true,
  version: appVersion,
  syncfusionLicenseKey: 'Mgo+DSMBaFt5QHFqVkNrXVNbdV5dVGpAd0N3RGlcdlR1fUUmHVdTRHRbQlVjTn5adkJgXn5WcnU='
};
